<template>
    <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="col-md-6">
                <input type="month" id='mes-de-doacoes-detalhadas'>
            </div>
            <div class="col-md-6">
                <button @click="getDoacoes()" class="btn btn-primary btn-micro">Gerar Relatório</button>
            </div>
        </div>
        <div v-show="download.load">
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <span>Pode demorar um pouco...</span>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../../router/urlApi'

export default {
  name: 'relatorioDoacoes',
  components: {
    ...spinners,
  },
  data () {
    return {
      download: {
        load: false
      },
    }
  },
  methods: {
    getDoacoes () {
      this.download.load = true
      let mes = document.getElementById('mes-de-doacoes-detalhadas').value
      this.$http.get(urlApi + '/cfc/relatorio/doacoes-por-autoescola-detalhadas/' + mes + '/' + true)
        .then(this.downloadCSV)
        .catch(err => {
          console.log(err)
          this.download.load = false
          this.$toasted.show(err.data.mensagem, {
            position: 'top-right',
          })
        })
    },
    downloadCSV (response) {
      if (response.data.dados) {
        let code64 = response.data.dados
        var csv = 'data:text/csv;charset=utf-8,' + code64

        var dlnk = document.getElementById('downloadCSV')
        dlnk.download = 'novoCFC.csv'
        dlnk.href = csv
        dlnk.click()
        this.download.load = false
      } else {
        this.$toasted.show('Consulta não possui resultado', {
          position: 'top-right',
        })
        this.download.load = false
      }
    },
  },
}
</script>

<style>

</style>
